/**
 * A whole number as the gamification forms take one. An Arabic keyboard types ٣ where the
 * server reads 3, so the digits are made Latin first. An empty field is `null`; anything that
 * is not a plain non-negative whole number — a sign, a decimal point, a letter — is `NaN`,
 * which fails every range check.
 */
export function wholeNumber(value) {
  const text = String(value ?? '')
    .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 0x06f0))
    .trim()
  if (text === '') return null
  return /^\d+$/.test(text) ? Number(text) : Number.NaN
}

/** True for a whole number from `min` to `max`. */
export const inRange = (number, min, max) => Number.isInteger(number) && number >= min && number <= max
